import { onBeforeUnmount, reactive, ref } from 'vue';
export default function useScroll(opts = {}) {
    const event = reactive({
        onBottom: () => true,
        onScroll: () => 0
    });

    let options = {
        scrollOffSet: 100,
        ...opts
    }
    const oldScrollTop = ref(0)

    const init = function () {
        window.onscroll = () => {
            let isDownward = false;
            if (oldScrollTop.value < window.scrollY) {
                isDownward = true;
            }

            oldScrollTop.value = window.scrollY;

            const pageHeight = Math.max(
                window.pageYOffset,
                document.documentElement.scrollTop,
                document.body.scrollTop
            );

            const bottomOfWindow =
                pageHeight + window.innerHeight >
                document.documentElement.offsetHeight - options.scrollOffSet;

            if (bottomOfWindow && pageHeight > 0 && isDownward) {
                event.onBottom();
            }
        }
    };
    onBeforeUnmount(() => {
        window.onscroll = null;
    })

    return {
        init,
        event
    }
}
